import { useRef } from 'react';
import { useNoiseShader } from '../hooks/useNoiseShader';
import styles from './NoiseCanvas.module.css';

export default function NoiseCanvas() {
  const canvasRef = useRef(null);
  useNoiseShader(canvasRef);
  return <canvas ref={canvasRef} className={styles.canvas} />;
}
